import React from 'react';
import PropTypes from 'prop-types';
import ProjectDescription from './project-description';
import ProjectDynamicFields from './project-dynamic-fields';
import '../project-form.scss';

const ProjectPageRightPanel = (
  {
    data,
    setFormState,
    dynamicFields,
    setDynamicFields,
  }
) => {
  return (
    <div>
        <ProjectDescription
            value={data.Description}
            handleFormChange={(field, value) => setFormState(field, value)}
        />
        {/* <ProjectTags
          value={data.Tags}
          handleFormChange={(field, value) => setFormState(field, value)}
        /> */}
        <div className='dynamicFields'>
          <ProjectDynamicFields
            templateId={data.ParentTemplateId}
            projectId={data.Id}
            dynamicFields={dynamicFields}
            setDynamicFields={setDynamicFields}
          />
        </div>
        
    </div>
  )
}

ProjectPageRightPanel.propTypes = {
  setFormState: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  dynamicFields: PropTypes.array,
  setDynamicFields: PropTypes.func,
}

export default ProjectPageRightPanel;